<template>
  <div>
    <div style="background-color: rgba(41, 155, 255, 0.1); margin: 20px; padding: 30px;height: 90vh;">
      <div style="color: rgb(7, 230, 248);">
      </div>
      <el-row style="margin-left: 35px; margin-top: 20px;overflow: auto;width: 100%; height: 100%">
        <el-row>大屏模板：</el-row>
        <ul class="templateUl">
          <li :key="item.id" @mouseleave="onMouseLeave" @mouseover="onMouseOver(item.id)" class="templateLi pointer"
              v-for="item in pageList">
            <div @touchstart="updateTemplate(item)" @click="updateTemplate(item)">
              <div style="text-align: center; font-weight:bold; margin-top: 5px;line-height: 30px;">{{
                  item.name
                }}
              </div>
              <div :style="{backgroundImage: 'url(' + $ftpUrl+item.bgImage + ')'}" class="template">
                <div :style="{backgroundImage: 'url('+ (item.id===pageId ? enableIcon : unEnableIcon) +')'}"
                     class="flex templateIcon">
                  <div style="margin-top: 10px">
                     <span style="color: white;">
                      {{ item.id === pageId ? '启 用' : '禁 用' }}
                     </span>
                  </div>
                </div>
              </div>
              <div style="margin: 10px 20px;float: left;">
                <div><span class="text-grey">大屏标题：</span>{{ item.title }}</div>
                <div><span class="text-grey">大屏简称：</span>{{ item.abbreviation }}</div>
                <div></div>
              </div>
            </div>
            <div style="position: absolute;right: 10px;top: 5px">
              <img @touchstart="() => edit(item)" @click="() => edit(item)" alt="编辑" ref="btnEdit"
                   src="@/assets/images/icon/edit.png" v-show="showBtn && showBtnId==item.id">
              <img @touchstart="() => deleteData(item.id)" @click="() => deleteData(item.id)" alt="删除" ref="btnDelete"
                   src="@/assets/images/icon/delete.png" style="z-index: 999;margin-left: 10px"
                   v-if="item.id !== pageId" v-show="showBtn && showBtnId==item.id">
            </div>
          </li>
        </ul>
      </el-row>
    </div>


    <!--    编辑弹出窗-->
    <function-dialog-component
      :dialog-title="title"
      :dialogVisible.sync="settingSaveDialogVisible"
      @dialogClose="(data) => this.settingSaveDialogVisible = data"
      center
      width="35vw">
      <div slot="content" style="padding: 10px 30px 20px 30px;height: 20vh">
        <PlatenSettingSave :code="code" :enable="startUsing" :settingValue="settingValue"
                           ref="platenSettingSave"></PlatenSettingSave>
      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 5px; margin-bottom: 15px;">
        <el-button @touchstart="() => {this.settingSaveDialogVisible = false;}" @click="() => {this.settingSaveDialogVisible = false;}" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation"  @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {deleteByDeviceCustomPageId, useCustomPage} from "@/network/device-custom-page";
import PlatenSettingSave from "@/views/platen/PlatenSettingSave";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";

export default {
  name: "PlatenTemplateList",
  props: ['pageList', 'pageId', 'code'],
  components: {FunctionDialogComponent, PlatenSettingSave},
  data() {
    return {
      title: '编辑大屏模板',
      pageUrl: "/platen/index",
      enableIcon: require("@/assets/images/sys-setting/large-size-screen/0.png"),
      unEnableIcon: require("@/assets/images/sys-setting/large-size-screen/1.png"),
      settingSaveDialogVisible: false,
      showBtn: false,
      settingValue: {},
      showBtnId: 0,
      startUsing: false
    }
  },
  methods: {
    onMouseOver(id) {
      this.showBtnId = id;
      this.showBtn = true;
    },
    onMouseLeave() {
      this.showBtnId = 0;
      this.showBtn = false;
    },
    //更新默认模板
    updateTemplate(item) {
      useCustomPage(this.code, item.id).then(res => {
        if (res.code === 0) {
          console.log(res);
          this.$emit('init')
        }
      })
    },
    // 删除模板
    deleteData(id) {
      this.$confirm('是否确认删除该模板', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            console.log(id);
            deleteByDeviceCustomPageId(id).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功");
                this.$emit('init');
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
      })
    },
    edit(item) {
      this.settingSaveDialogVisible = true;
      this.startUsing = item.id == this.pageId;
      console.log(this.startUsing);
      this.settingValue = JSON.parse(JSON.stringify(item));
    },
    // 保存
    preservation() {
      this.$refs.platenSettingSave.editCustomPage();
    },
  }
}
</script>

<style scoped>
.templateUl {
  width: 100%;
  height: auto;
  list-style: none;
  padding: 0;
}

.templateLi {
  width: 350px;
  height: 260px;
  margin: 25px 40px 20px 0;
  position: relative;
  border: 1px solid rgba(41, 155, 255, .1);
  background-color: rgba(41, 155, 255, .1);
  padding: 0 10px;
  float: left;
}

.template {
  width: 300px;
  height: 150px;
  margin: 5px auto 0;
  background: no-repeat center top;
  background-size: contain;
}

.templateIcon {
  width: 46px;
  height: 55px;
  position: absolute;
  top: 40px;
  float: left;
  text-align: center;
}
</style>
